import { C } from "../constants/theme";

// Mostra as placas que esse arquivo .3mf tem — só informativo (Produtos >
// Mídia e arquivos). Não define o que aparece pro cliente: isso é o campo
// "Modelo 3D para exibição", anexado na Calculadora ao registrar o produto
// ou o orçamento (é o que liga o botão "Ver em 3D" no site e no orçamento).
export function Configurar3D({ arquivo }) {
  if (!arquivo.placas?.length) return null;
  return (
    <div style={{ display:"flex", flexWrap:"wrap", gap:8, padding:"8px 0" }}>
      {arquivo.placas.map(p => (
        <div key={p.indice} style={{ width:64, textAlign:"center" }}>
          <div style={{ width:64, height:64, borderRadius:8, overflow:"hidden", background:C.panel, border:"1px solid "+C.border }}>
            {p.thumbnail && <img src={p.thumbnail} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} />}
          </div>
          <div style={{ fontSize:10, color:C.muted, marginTop:4, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{p.nome}</div>
        </div>
      ))}
    </div>
  );
}
